import { Button } from '~/shared/components/buttons/Button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';

export function SelectingInterventionFooter() {
	const { wizardState, dispatch } = useGoalsAndInterventionsWizard();

	return (
		<div className="flex items-center gap-2">
			<Button onClick={() => dispatch({ type: 'PREVIOUS_CLICKED' })} Icon={ChevronLeft} label="Previous" />
			<Button
				onClick={() => dispatch({ type: 'NEXT_CLICKED' })}
				Icon={ChevronRight}
				label="Next"
				isDisabled={wizardState.selectedInterventions.length === 0}
			/>
		</div>
	);
}
